import _extends from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["modalId"];
var _MODAL_COMPONENTS;
var __jsx = React.createElement;
import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import { hideModalAction } from '@spa/shared/store/actions/modal';
import ReportListing from './ReportListing';
import PhotosModal from './PhotosModal';
import Share from './Share';
import Wishlist from './Wishlist';
import Features from './Features';
import ReviewsModal from './Reviews';
import EnergyCertificationModal from '@spa/shared/components/Modals/EnergyCertificationModal';
import MapViewModal from './MapViewModal';
import PaymentSummaryModal from './PaymentSummaryModal';
import DoubleBookingModal from './DoubleBookingModal';
import GenderRestrictionModal from './GenderRestrictionModal';
export var modalIds = {
  REPORT_LISTING: 'report-listing',
  PHOTOS_MODAL: 'photos-modal',
  SHARE: 'share',
  WISHLIST: 'wishlist',
  FEATURES: 'features',
  REVIEWS: 'reviews',
  ENERGY_CERTIFICATION: 'energy-certification',
  MAP: 'map',
  PAYMENT_SUMMARY: 'payment-summary',
  DOUBLE_BOOKING: 'double-booking',
  GENDER_RESTRICTION: 'gender-restriction'
};
var MODAL_COMPONENTS = (_MODAL_COMPONENTS = {}, _defineProperty(_MODAL_COMPONENTS, modalIds.REPORT_LISTING, ReportListing), _defineProperty(_MODAL_COMPONENTS, modalIds.PHOTOS_MODAL, PhotosModal), _defineProperty(_MODAL_COMPONENTS, modalIds.SHARE, Share), _defineProperty(_MODAL_COMPONENTS, modalIds.WISHLIST, Wishlist), _defineProperty(_MODAL_COMPONENTS, modalIds.FEATURES, Features), _defineProperty(_MODAL_COMPONENTS, modalIds.REVIEWS, ReviewsModal), _defineProperty(_MODAL_COMPONENTS, modalIds.ENERGY_CERTIFICATION, EnergyCertificationModal), _defineProperty(_MODAL_COMPONENTS, modalIds.MAP, MapViewModal), _defineProperty(_MODAL_COMPONENTS, modalIds.PAYMENT_SUMMARY, PaymentSummaryModal), _defineProperty(_MODAL_COMPONENTS, modalIds.DOUBLE_BOOKING, DoubleBookingModal), _defineProperty(_MODAL_COMPONENTS, modalIds.GENDER_RESTRICTION, GenderRestrictionModal), _MODAL_COMPONENTS);
var ModalDisplayer = function ModalDisplayer(_ref) {
  var _modals;
  var modals = _ref.modals,
    hideModal = _ref.hideModal;
  var activeModalId = (_modals = modals[modals.length - 1]) === null || _modals === void 0 ? void 0 : _modals.modalId;
  var handleClose = useCallback(function (modalId) {
    if (modalId !== activeModalId) {
      return;
    }
    hideModal(modalId);
  }, [activeModalId, hideModal]);
  return __jsx(React.Fragment, null, modals.map(function (_ref2) {
    var modalId = _ref2.modalId,
      state = _objectWithoutProperties(_ref2, _excluded);
    var ModalComponent = MODAL_COMPONENTS[modalId];
    return ModalComponent ? __jsx(ModalComponent, _extends({}, state, {
      key: modalId,
      onClose: function onClose() {
        return handleClose(modalId);
      }
    })) : null;
  }));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var modals = _ref3.modal.modals;
  return {
    modals: modals
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideModal: function hideModal(modalId) {
      return dispatch(hideModalAction(modalId));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)( /*#__PURE__*/memo(ModalDisplayer));